import * as Sentry from '@sentry/react'
import { browserTracingIntegration, replayIntegration } from '@sentry/react'

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development'

  if (!dsn) {
    console.log('[Sentry] DSN no configurado, saltando inicialización')
    return
  }

  Sentry.init({
    dsn,
    environment,
    integrations: [
      browserTracingIntegration(),
      replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance monitoring
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    // Session replay
    replaysSessionSampleRate: environment === 'production' ? 0.01 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Debug
    debug: environment === 'development',
    // Ignore certain errors
    ignoreErrors: [
      // Ignorar errores de red comunes
      'NetworkError',
      'Failed to fetch',
      // Ignorar errores de cancelación de React Query
      'QueryClient.setQueryData',
    ],
    beforeSend(event) {
      // No enviar errores en desarrollo a Sentry
      if (environment === 'development') {
        console.log('[Sentry] Error capturado (dev):', event.exception?.values?.[0]?.value)
        return null
      }
      return event
    },
  })

  console.log('[Sentry] Inicializado en', environment)
}

// Helper para capturar errores manuales
export function captureError(error: Error, context?: Record<string, unknown>) {
  Sentry.captureException(error, { extra: context })
}

// Helper para agregar breadcrumbs
export function addBreadcrumb(category: string, message: string, data?: Record<string, unknown>) {
  Sentry.addBreadcrumb({
    category,
    message,
    level: 'info',
    data,
  })
}

// Helper para establecer contexto de usuario
export function setUserContext(user: { id: string; email?: string; tenant_id?: string }) {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    tenant_id: user.tenant_id,
  })
}

// Helper para limpiar contexto de usuario
export function clearUserContext() {
  Sentry.setUser(null)
}